export function getDeviceId() {
  return "Web"
}
